exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-d8754dd4]  .dialog_box{border-radius:10px}.box[data-v-d8754dd4]  .dialog_box .el-dialog__header{border-radius:10px 10px 0 0;background:#ecf4ff;color:#282828;font-weight:600;font-size:22px}.box .from_box[data-v-d8754dd4]{padding:0 80px}.avatar-uploader .el-upload[data-v-d8754dd4]{border:1px dashed #f7f7f7;border-radius:10px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-d8754dd4]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-d8754dd4]{font-size:28px;color:#8c939d;width:130px;height:130px;line-height:130px;text-align:center}", ""]);

// exports
